module.exports = __webpack_public_path__ + "de948358ed43c13f75400033bb9f7831.svg";